<template>
  <Modal
    :title="$t('edit_bank_account')"
    modalId="edit-modal"
    @submit="updateAccount"
  >
    <form @submit.prevent="updateAccount">
      <div class="mb-3">
        <label class="form-label">{{ $t('bank_account_number') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="account.node"
          class="form-control"
        />
        <!-- Error for account node -->
        <div v-if="errors.node" class="text-danger mt-2">
          <span>{{ errors.node }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '@/urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },
  props: {
    selectedAccount: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      account: {
        id: null,
        node: '',
      },
      errorMessage: '',
      errors: {},
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  watch: {
    selectedAccount: {
      immediate: true,
      handler(newAccount) {
        if (newAccount && newAccount.id) {
          this.account = { ...newAccount }; // Copy selected Account data
        }
      },
    },
  },
  methods: {
    async updateAccount() {
      try {
        const response = await this.$axios.patch(
          apiUrls.bank_account_head.update.replace(':pk', this.account.id),
          { node: this.account.node }
        );

        this.toast.success('Bank head successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'node' field is in errors and assign full error message
            if (error.response.data.node && error.response.data.node.length > 0) {
              // Assign the full error message from the array
              this.errors.node = error.response.data.node[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.account = { id: null, node: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>

